//@flow
import React, { Component } from 'react';
import {
  FiltersDiv,
  FiltersSectionDiv,
  ReferredPartnerTransactionFilterDiv,
  CustomCsvFilter,
  CustomCalendarFilter
} from './ReferredPartnersIndex/ReferredPartnersIndexStyles';
import { Default, Mobile } from '../../components/Responsive';
import SearchStatic from '../../components/SearchStatic';

export type ReferredPartnerFilterProps = {
  toggleCalendarFilter: () => void,
  calendarFilterState: boolean,
  calendarStart: moment$Moment,
  calendarEnd: moment$Moment,
  clearCalendarFilter: () => void,
  setCalendarStartFilter: (date: ?moment$Moment) => void,
  setCalendarEndFilter: (date: ?moment$Moment) => void,
  setCalendarSaga: () => void,
  downloadCsv: () => void,
  searchValue: string,
  setSearchFilter: () => void
};

type Props = {
  windowSize: string,
  disabled: boolean
} & ReferredPartnerFilterProps;

class ReferredPartnerFilters extends Component<Props> {
  renderSearchFilter = (rightEnd: boolean = false) => (
    <ReferredPartnerTransactionFilterDiv rightEnd={rightEnd}>
      <SearchStatic
        handleSearchChange={this.props.setSearchFilter}
        searchValue={this.props.searchValue}
        disabled={this.props.disabled}
        placeholder="Partner name, Contact name, email ..."
        hideBorderBottom
      />
    </ReferredPartnerTransactionFilterDiv>
  );

  renderDateFilter = () => (
    <CustomCalendarFilter
      toggleCalendarFilter={this.props.toggleCalendarFilter}
      calendarFilterState={this.props.calendarFilterState}
      calendarStart={this.props.calendarStart}
      calendarEnd={this.props.calendarEnd}
      clearCalendarFilter={this.props.clearCalendarFilter}
      setCalendarStartFilter={this.props.setCalendarStartFilter}
      setCalendarEndFilter={this.props.setCalendarEndFilter}
      windowSize={this.props.windowSize}
      setCalendarSaga={this.props.setCalendarSaga}
      disabled={this.props.disabled}
    />
  );

  renderCsvFilter = () => (
    <CustomCsvFilter
      rightEnd
      filterRow
      handleCsvFilter={this.props.downloadCsv}
      disabled={this.props.disabled}
    />
  );

  render() {
    return (
      <FiltersDiv>
        <FiltersSectionDiv>
          <Default>
            {this.renderSearchFilter()}
            {this.renderDateFilter()}
            {this.renderCsvFilter()}
          </Default>
          <Mobile>
            {this.renderSearchFilter()}
            {this.renderDateFilter()}
          </Mobile>
        </FiltersSectionDiv>
      </FiltersDiv>
    );
  }
}

export default ReferredPartnerFilters;
